export const COUNTRIES = {
  MEXICO: 'Mexico',
  CHILE: 'Chile',
};
